'use strict';
import * as $j_app$002edata$002e$002dGoogle$002dSign$002dIn$002dError from "./app.data.-Google-Sign-In-Error.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_GoogleSignInError$Other(err) {
  this.Y4 = null;
  this.Y4 = err;
}
export { $c_Lapp_data_GoogleSignInError$Other as $c_Lapp_data_GoogleSignInError$Other };
$p = $c_Lapp_data_GoogleSignInError$Other.prototype = new $j_app$002edata$002e$002dGoogle$002dSign$002dIn$002dError.$h_Lapp_data_GoogleSignInError();
$p.constructor = $c_Lapp_data_GoogleSignInError$Other;
/** @constructor */
function $h_Lapp_data_GoogleSignInError$Other() {
}
export { $h_Lapp_data_GoogleSignInError$Other as $h_Lapp_data_GoogleSignInError$Other };
$h_Lapp_data_GoogleSignInError$Other.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_GoogleSignInError$Other) && (this.Y4 === x$0.Y4)));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Other";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Y4;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 3;
});
function $isArrayOf_Lapp_data_GoogleSignInError$Other(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jx)));
}
export { $isArrayOf_Lapp_data_GoogleSignInError$Other as $isArrayOf_Lapp_data_GoogleSignInError$Other };
var $d_Lapp_data_GoogleSignInError$Other = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_GoogleSignInError$Other, "app.data.GoogleSignInError$Other", ({
  jx: 1,
  jw: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_GoogleSignInError$Other as $d_Lapp_data_GoogleSignInError$Other };
//# sourceMappingURL=app.data.-Google-Sign-In-Error$-Other.js.map
